import { Sheet } from "./Sheet";
import { useI18n } from "@/i18n";

interface Props {
  open: boolean;
  imageUrl: string | null;
  onCancel: () => void;
  /** Called when the user confirms deletion (after optional download). */
  onDelete: () => void;
}

/**
 * Universal image-deletion safeguard (PRD §5.6).
 * Used for EVERY image deletion across the app (logo, references, photos,
 * generated outputs).
 */
export function ImageDeleteGuard({ open, imageUrl, onCancel, onDelete }: Props) {
  const { t } = useI18n();

  function downloadThenDelete() {
    if (imageUrl) {
      const a = document.createElement("a");
      a.href = imageUrl;
      a.download = imageUrl.split("/").pop() ?? "vira-image";
      a.target = "_blank";
      a.rel = "noopener";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }
    onDelete();
  }

  return (
    <Sheet open={open} onClose={onCancel} title={t("deleteWarnTitle")}>
      <p className="mb-5 text-sm text-muted">{t("deleteWarnBody")}</p>
      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          className="mb-5 max-h-40 w-full rounded-xl object-contain ring-1 ring-slate-100"
        />
      )}
      <div className="grid gap-2">
        <button className="btn-primary" onClick={downloadThenDelete}>
          {t("downloadDelete")}
        </button>
        <button
          className="btn bg-red-50 text-red-600 ring-1 ring-red-100"
          onClick={onDelete}
        >
          {t("deleteAnyway")}
        </button>
        <button className="btn-ghost" onClick={onCancel}>
          {t("cancel")}
        </button>
      </div>
    </Sheet>
  );
}
